import { useCallback, useEffect, useMemo, useState } from "react"
import { useDispatch } from 'react-redux'
import { callApiAction } from "../../../store/actions/commonAction"
import { getUserApi, updateUserField } from "../../../apis/user.api"
import { useParams } from "react-router-dom"
import { openModal } from "../../../store/actions/modalAction"
import PendingLeaveUi from "./PendingLeaveUi"
import { getLeavesApi, getPendingCoffApi, getPendingLeavesApi } from "../../../apis/leave.api"
import moment from "moment"
import { findObjectKeyByValue } from "../../../utils/helper"
import { Typography } from "@mui/material"
import CoffViewButton from "./CoffViewButton"
import { LEAVE_TYPE } from "../../../utils/leave.constants"
import { HALF_TYPE_OBJ } from "../../../utils/constants"
import PendingCoffUi from "./PendingCoffUi"

const PendingCoffController = ({ userId, pendingAndGenral }) => {
    const dispatch = useDispatch()
    const params = useParams()
    const [list, setList] = useState([])

    const columns = useMemo(() => [
        { id: 1, fieldName: 'createdAt', label: 'Application Date', align: "left", sort: true, minWidth: '150px', renderValue: (params) => moment(params.createdAt ?? params.date).format("DD/MM/YYYY") },

        { id: 8, fieldName: 'applied_by', label: 'Applied By', align: "left", minWidth: '150px', renderValue: (params) => <Typography fontSize="inherit" textTransform="capitalize">{params.applied_by?.first_name + " " + params.applied_by?.last_name}</Typography> },
        {
            id: 3, fieldName: 'from', label: 'Date', align: "left", sort: true, minWidth: '150px', renderValue: (params) => {
                let str = moment(params.date).format("DD/MM/YYYY")

                return str
            }
        },
        { id: 2, fieldName: 'time_duration', label: 'Time Duration', align: "left", sort: true, minWidth: '150px', renderValue: (params) => params.time_duration == HALF_TYPE_OBJ.FULL_DAY ? 1 : 0.5 },

        {
            id: 6, fieldName: 'action', label: 'Action', align: "left", renderValue: (params, setParams) => <CoffViewButton id={params._id} />
        },
    ], [dispatch]);

    const [listLoading, setListLoading] = useState(false)


    const [filters, setFilters] = useState({

        pageNo: 1,
        pageSize: 10,
        date: moment(),
        userId: userId

    })

    const fetchList = () => {
        setListLoading(true)
        const parmasToPass = { ...filters }
        parmasToPass.date = parmasToPass.date.valueOf()
        dispatch(callApiAction(
            async () => await getPendingCoffApi({ ...parmasToPass }),
            (response) => {
                setList(response)

                setListLoading(false)
            },
            (err) => {
                setListLoading(false)
            }
        ))
    }



    useEffect(() => {
        fetchList()
    }, [filters])



    return (
        <>
            <PendingCoffUi
                columns={columns}
                pendingAndGenral={pendingAndGenral}
                listLoading={listLoading}
                filters={filters}
                setFilters={setFilters}
                callBack={fetchList}
                list={list}
                isFromCoff
            />

        </>
    )
}
export default PendingCoffController